module.exports = __webpack_public_path__ + "static/media/image2.a6c8129a.png";